import React from 'react';
import './common.css';

/**
 * A simple spinner component for loading states
 */
function Spinner() {
  return (
    <div className="spinner">
      <div className="spinner-inner"></div>
    </div>
  );
}

export { Spinner };
